import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Typography } from 'antd';
import {
  LaptopOutlined,
  EnvironmentOutlined,
  BookOutlined,
  ZoomInOutlined,
  BuildFilled,
  UserAddOutlined,
} from '@ant-design/icons';
import '../../Styles/HomeStyles.css';

const { Title } = Typography;

const impactStats = [
  { value: 109, label: 'Software and Hardware Solutions', icon: LaptopOutlined },
  { value: 440, label: 'Geographical Models and Maps', icon: EnvironmentOutlined },
  { value: 353, label: 'Research Publications', icon: BookOutlined },
  { value: 758, label: 'Research Impact Factor', icon: ZoomInOutlined },
  { value: 496, label: 'Industry Academia Linkages', icon: BuildFilled },
  { value: 11231, label: 'Human Resource Development', icon: UserAddOutlined },
];

const CountUp = ({ active, value, duration = 1700 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(0);
    if (!active) return undefined;

    let frameId;
    let startTime;

    const animate = (timestamp) => {
      if (startTime === undefined) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 4);
      setCount(Math.round(value * easedProgress));
      if (progress < 1) frameId = window.requestAnimationFrame(animate);
    };

    frameId = window.requestAnimationFrame(animate);
    return () => window.cancelAnimationFrame(frameId);
  }, [active, duration, value]);

  return <>{count}</>;
};

const ImpactSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!sectionRef.current || !('IntersectionObserver' in window)) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.25 }
    );

    observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="home-impact-section" aria-labelledby="impact-title">
      <div className="impact-content">
        <Title id="impact-title" className="impact-title" level={2}>Impacts</Title>
        <Row gutter={[20, 34]} justify="space-between" align="top" className="impact-stats">
          {impactStats.map(({ value, label, icon: Icon }) => (
            <Col xs={24} sm={12} lg={8} key={label}>
              <div className="impact-item">
                <Icon className="impact-icon" aria-hidden="true" />
                <div className="impact-number" aria-label={`${value} ${label}`}>
                  <CountUp active={isVisible} value={value} />
                </div>
                <p>{label}</p>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default ImpactSection;
